var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var ui_extensions = require("ui-extensions");

var PolyLineToolStateMachine = require("./polyLineToolStateMachine.js");
var PolyLineToolView = require("./polyLineToolView.js");
var PolyLineToolModel = require("./polyLineToolModel.js");
var AbstractToolController = require("./../../../extensions/abstractToolController.js");

var PolyLineToolController = function(archLayers, dependencies, options) {
    this.setDefaultConfiguration({
        flip: 1,
        fill: false,
        strokeWidth: 2,
        PathClass: cio_datamodel.PathData,
        stateMachineMode : cio_datamodel.PolyPointMode.STRAIGHT
    });

    lib_core.GuiEvents.addEvents({
        CHANGE_POLYLINE_MODE:  {id: 'pl_0', name: "CHANGE_POLYLINE_MODE" },
        CHANGE_POLYLINE_AXIS:  {id: 'pl_1', name: "CHANGE_POLYLINE_AXIS"}
    });

    AbstractToolController.call(this, archLayers, dependencies, options);

    // TODO remove after development is complete
    // console.log(" == POLYLINE TOOL INSTRUCTIONS == ");
    // console.log("  'd' to switch from straight,corner, or 45/90/180 deg arc");
    // console.log("  'f' to switch FROM or TO direction for arc");
    // console.log("  'spacebar' to toggle axis selection");
    // console.log(" == ========================== == ");
};

lib_core.inherit(PolyLineToolController, AbstractToolController);
PolyLineToolController.inject = AbstractToolController.inject;
PolyLineToolController.inject.tabController = ui_extensions.TabController;
PolyLineToolController.StateMachineClass = PolyLineToolStateMachine;

module.exports = PolyLineToolController;

PolyLineToolController.prototype.getButtonElements = function () {
    var buttonElements = {
        name: 'Polyline',
        title: 'Polyline',
        style: {
            icon: 'icon-polyline.svg',
        },
        eventData: {
            "tool": this.name()
        },
        auto_escape: true
    };

    return buttonElements;
};

PolyLineToolController.prototype.createModel = function () {
    return new PolyLineToolModel(this.configuration);
};

PolyLineToolController.prototype.createView = function () {
    var editorView = this.editor2DController.getView();
    var tabView = this.tabController.getView();
    return new PolyLineToolView(tabView, editorView, this.getModel());
};
